import type { NowaPozycjaCzesci } from '../api';
import { IkonaPlus } from './Icons';
import { Karta, PoleTekstowe, Przycisk } from './ui';

/**
 * Wykaz zużytych części — ten sam edytor przy wystawianiu zlecenia i przy jego
 * uzupełnianiu, bo to ta sama tabelka z druku.
 *
 * Pozycje nie mają w interfejsie własnej tożsamości (nie ma „edytuj pozycję nr 3"),
 * więc zapis zastępuje całą listę. Udawanie, że mają, wymagałoby identyfikatorów,
 * których nikt tu nie widzi.
 */
export function EdytorCzesci({
  czesci,
  onZmiana,
}: {
  czesci: NowaPozycjaCzesci[];
  onZmiana: (czesci: NowaPozycjaCzesci[]) => void;
}) {
  const zmien = (indeks: number, zmiana: Partial<NowaPozycjaCzesci>): void =>
    onZmiana(czesci.map((pozycja, i) => (i === indeks ? { ...pozycja, ...zmiana } : pozycja)));

  return (
    <Karta
      tytul={`Zużyte części · ${czesci.length}`}
      akcje={
        <Przycisk
          type="button"
          onClick={() => onZmiana([...czesci, { opis: '', ilosc: 1 }])}
          ikona={<IkonaPlus rozmiar={16} />}
        >
          Dodaj pozycję
        </Przycisk>
      }
    >
      {czesci.length === 0 ? (
        <p className="t-small text-n-600">
          Pusto — wykaz uzupełnia się w trakcie montażu, nie przy wystawianiu zlecenia.
        </p>
      ) : (
        czesci.map((pozycja, indeks) => (
          <div
            key={indeks}
            className="mb-13 grid gap-13 last:mb-0 sm:grid-cols-[1fr_2fr_auto_auto]"
          >
            <PoleTekstowe
              etykieta="Numer części"
              value={pozycja.numerCzesci ?? ''}
              onChange={(z) => zmien(indeks, { numerCzesci: z.target.value })}
              autoComplete="off"
            />
            <PoleTekstowe
              etykieta="Opis"
              value={pozycja.opis}
              onChange={(z) => zmien(indeks, { opis: z.target.value })}
              autoComplete="off"
            />
            <PoleTekstowe
              type="number"
              min={0}
              step="0.01"
              etykieta="Ilość"
              value={String(pozycja.ilosc ?? 1)}
              onChange={(z) => zmien(indeks, { ilosc: Number(z.target.value) })}
            />
            <div className="flex items-end">
              <Przycisk
                type="button"
                onClick={() => onZmiana(czesci.filter((_, i) => i !== indeks))}
              >
                Usuń
              </Przycisk>
            </div>
          </div>
        ))
      )}
    </Karta>
  );
}
